import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo_emc from "../../../assets/logos/logo_emc_text_dark.svg";
import "./Access.css";

function Access() {
  const [code, setCode] = useState("");
  const navigate = useNavigate();
  const requiredCode = process.env.REACT_APP_REQUIRED_ACCESS_CODE;

  function handleCodeSubmit() {
    if (code === requiredCode) {
      localStorage.setItem("accessCode", code);
      navigate("/");
    } else {
      alert("Code incorrect");
    }
  }

  return (
    <>
      <main className='main-access'>
        <section class='advice'>
          <div className='img-cont'>
            <img src={logo_emc} alt='TODO' className='img-logo' />
          </div>

          <div classname=''>
            <div classname=''>
              <h1 classname=''>Prêt pour une nouvelle expérience&nbsp;?</h1>
            </div>
          </div>
          <div className='p-cont'>
            <h2>Maintenance en cours</h2>
            <p className='m-top'>
              Notre site EstimerMonCommerce.fr est actuellement en cours de mise à jour vers sa toute nouvelle version.
            </p>
            <p className='m-top'>
              {" "}
              Cette mise à jour vise à vous offrir une expérience plus fluide, de nouvelles fonctionnalités et des
              performances améliorées.
            </p>
            <p className='m-top'>
              Cette maintenance est temporaire et ne devrait pas durer longtemps. Nous faisons tout notre possible pour
              que le site soit de nouveau disponible rapidement.
            </p>
            <p className='m-top'>Merci de votre patience et de votre compréhension !</p>
            <p className='m-top'>L’équipe estimermoncommerce</p>
          </div>
          <div className='access-page'>
            <h1 className='h1-access'>Accès administrateurs</h1>
            <div>
              <input type='text' value={code} onChange={e => setCode(e.target.value)} placeholder='Entrez le code' />
              <button onClick={handleCodeSubmit}>Valider</button>
            </div>
          </div>
        </section>
        <section class='city-stuff'>
          <ul class='skyscrappers__list'>
            <li class='skyscrapper__item skyscrapper-1'></li>
            <li class='skyscrapper__item skyscrapper-2'></li>
            <li class='skyscrapper__item skyscrapper-3'></li>
            <li class='skyscrapper__item skyscrapper-4'></li>
            <li class='skyscrapper__item skyscrapper-5'></li>
          </ul>
          <ul class='tree__container'>
            <li class='tree__list'>
              <ul class='tree__item tree-1'>
                <li class='tree__trunk'></li>
                <li class='tree__leaves'></li>
              </ul>
              <ul class='tree__item tree-2'>
                <li class='tree__trunk'></li>
                <li class='tree__leaves'></li>
              </ul>
              <ul class='tree__item tree-3'>
                <li class='tree__trunk'></li>
                <li class='tree__leaves'></li>
              </ul>
              <ul class='tree__item tree-4'>
                <li class='tree__trunk'></li>
                <li class='tree__leaves'></li>
              </ul>
              <ul class='tree__item tree-5'>
                <li class='tree__trunk'></li>
                <li class='tree__leaves'></li>
              </ul>
              <ul class='tree__item tree-6'>
                <li class='tree__trunk'></li>
                <li class='tree__leaves'></li>
              </ul>
              <ul class='tree__item tree-7'>
                <li class='tree__trunk'></li>
                <li class='tree__leaves'></li>
              </ul>
              <ul class='tree__item tree-8'>
                <li class='tree__trunk'></li>
                <li class='tree__leaves'></li>
              </ul>
            </li>
          </ul>
          <ul class='crane__list crane-1'>
            <li class='crane__item crane-cable crane-cable-1'></li>
            <li class='crane__item crane-cable crane-cable-2'></li>
            <li class='crane__item crane-cable crane-cable-3'></li>
            <li class='crane__item crane-stand'></li>
            <li class='crane__item crane-weight'></li>
            <li class='crane__item crane-cabin'></li>
            <li class='crane__item crane-arm'></li>
          </ul>
          <ul class='crane__list crane-2'>
            <li class='crane__item crane-cable crane-cable-1'></li>
            <li class='crane__item crane-cable crane-cable-2'></li>
            <li class='crane__item crane-cable crane-cable-3'></li>
            <li class='crane__item crane-stand'></li>
            <li class='crane__item crane-weight'></li>
            <li class='crane__item crane-cabin'></li>
            <li class='crane__item crane-arm'></li>
          </ul>
          <ul class='crane__list crane-3'>
            <li class='crane__item crane-cable crane-cable-1'></li>
            <li class='crane__item crane-cable crane-cable-2'></li>
            <li class='crane__item crane-cable crane-cable-3'></li>
            <li class='crane__item crane-stand'></li>
            <li class='crane__item crane-weight'></li>
            <li class='crane__item crane-cabin'></li>
            <li class='crane__item crane-arm'></li>
          </ul>
        </section>
      </main>
    </>
  );
}

export default Access;
